/**
 * The times of the server are UTC with their Z (e.g. "2026-10-14T06:56:00.000Z") and are
 * shown in the time of the browser. An older form without a zone ("2026-10-14 09:56:00")
 * is read as a local time, as before.
 */
export const parseServerTime = (value: string): Date =>
  /^\d{4}-\d{2}-\d{2} \d/.test(value)
    ? new Date(value.replace(' ', 'T'))
    : new Date(value);

const twoDigits = (value: number) => `${value}`.padStart(2, '0');

// E.g. "14.10.2026"
export const formatServerDate = (value: string): string => {
  const time = parseServerTime(value);
  return `${twoDigits(time.getDate())}.${twoDigits(
    time.getMonth() + 1
  )}.${time.getFullYear()}`;
};

// E.g. "14.10.2026 09:56"
export const formatServerDateTime = (value: string): string => {
  const time = parseServerTime(value);
  return `${formatServerDate(value)} ${twoDigits(time.getHours())}:${twoDigits(
    time.getMinutes()
  )}`;
};
